import ErrorPage from 'js/pages/error/index.js'
import EmailConfirmation from 'js/pages/email-confirmation/index.js'

const meta = {
  layoutInfo: true,
  layout: 'default'
}
export default [
  {
    path: '/error/:errorCode',
    name: 'error',
    component: ErrorPage,
    meta
  },
  // Confirmación de email por enlace
  {
    path: '/confirmation',
    alias: '/confirm-email',
    name: 'email-confirmation',
    component: EmailConfirmation,
    meta
  },
  {
    path: '*',
    redirect: '/'
  }
]
